export enum GiftActionFlow {
  giftCountry = 'giftCountry',
  campaignCountry = 'campaignCountry',
  wrongCountry = 'wrongCountry',
  activate = 'activate',
  loading = 'loading',
}
